export enum Order {
  asc = 'asc',
  desc = 'desc',
}
